
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type relatedItemsRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function relatedItemsRT(): TemplateResult<relatedItemsRTRootProps> {
    function repeatItems1(showExactFitBadge, items, itemsIndex) {
        return [items(function () {
                function repeatBadge1(badge, badgeIndex) {
                    return _createElement('div', {
                        'className': 'badge cm_badge cm_badge__' + this.toKebabCase(badge),
                        'key': badge
                    }, '\n      ', badge, '\n    ');
                }
                function mergeProps(inline, external) {
                    var res = Object.assign({}, inline, external);
                    if (inline.hasOwnProperty('style')) {
                        res.style = _.defaults(res.style, inline.style);
                    }
                    if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                        res.className = external.className + ' ' + inline.className;
                    }
                    return res;
                }
                function repeatI3(i, iIndex) {
                    return _createElement('span', {
                        'key': i,
                        'className': 'cm_star cm_star__' + (!(this.review_average - i) || this.review_average - i < 0.25 ? 'empty' : this.review_average - i < 0.75 ? 'half' : 'full')
                    });
                }
                function scopeProduct4() {
                    var product = this.productData ?? this;
                    return [product.is_autosync_allowed ? _createElement('button', {
                            'className': 'cm_view-on-vehicle-btn cm_button cm_button__secondary',
                            'onClick': () => window.Convermax.openAutoSyncDialog(product.autosync_id, product.autosync_mpn, product.FitmentType?.includes('Tire')),
                            'type': 'button',
                            'key': '41171'
                        }, '\n    ', _translate(`view_product_on_vehicle`), '\n  ') : null];
                }
                return _createElement('div', { 'className': 'cm_product-item grid-item__link' + (this.is_promotional_item ? ' cm_promotion' : '') }, _createElement.apply(this, [
                    'div',
                    { 'className': 'cm_badge-container' },
                    this.on_sale ? _createElement('div', {
                        'className': 'badge cm_badge cm_badge__sale',
                        'key': '154'
                    }, '\n      Save ', this.formatPrice(this.compare_at_price - this.price), '\n    ') : null,
                    this._badges ? _map(this._badges, repeatBadge1.bind(this)) : null,
                    showExactFitBadge && this.Fitment === 'Vehicle Specific' ? _createElement('div', {
                        'className': 'badge cm_badge cm_badge__exactFit',
                        'key': '463'
                    }, '\n      ', _translate(`product_exact_fit`), '\n    ') : null
                ]), _createElement('a', {
                    'href': this.url,
                    'className': 'cm_product-item__image-container'
                }, _createElement('img', {
                    'className': 'cm_product-item__image' + (this.image2 ? ' cm_product-item__image_primary' : ''),
                    'src': this.imageOrDefault(this.resizeImage(this.image)),
                    'alt': this.removeHTML(this.title),
                    'onError': this.onImageError
                }), this.image2 ? _createElement('img', {
                    'className': 'cm_product-item__image cm_product-item__image_secondary',
                    'src': this.resizeImage(this.image2),
                    'alt': this.removeHTML(this.title),
                    'onError': e => this.onImageError(e, 'image2'),
                    'key': '964'
                }) : null), _createElement('div', { 'className': 'cm_product-item__details' }, _createElement('a', mergeProps({
                    'href': this.url,
                    'className': 'cm_product-item__title'
                }, { dangerouslySetInnerHTML: { __html: typeof this.breakWordOnSlash(this.title) === 'undefined' ? '' : this.breakWordOnSlash(this.title) } })), _createElement('div', { 'className': 'cm_product-item__price-container' }, this.on_sale ? _createElement('div', {
                    'className': 'cm_product-item__price cm_product-item__price_compare',
                    'key': '1524'
                }, '\n        ', this.formatPrice(this.compare_at_price), '\n      ') : null, _createElement('div', { 'className': 'cm_product-item__price' }, this.price_varies ? _createElement('span', { 'key': '1727' }, _translate(`price_from`), ' ') : null, '\n        ', this.formatPrice(this.min_price || this.price), '\n      '), this.set_qty && !this.price_varies ? _createElement('div', {
                    'className': 'cm_product-item__price cm_product-item__price_set',
                    'key': '1871'
                }, '\n        ', _translate(`product_set_of`, {  count: this.set_qty  }), ': ', this.formatPrice(this.price * this.set_qty), '\n      ') : null), [this.review_count ? _createElement.apply(this, [
                        'div',
                        {
                            'className': 'cm_review-stars',
                            'key': '21260'
                        },
                        _map([
                            0,
                            1,
                            2,
                            3,
                            4
                        ], repeatI3.bind(this)),
                        _createElement('span', { 'className': 'cm_review-count' }, '(', this.review_count, ')')
                    ]) : null], this.price ? _createElement('p', {
                    'className': 'affirm-as-low-as',
                    'data-amount': this.price * 100,
                    'data-affirm-type': 'logo',
                    'data-affirm-color': 'blue',
                    'key': '2527'
                }) : null), _createElement('div', { 'className': 'cm_product-item__buttons' }, _createElement('form', {
                    'action': '/cart/add',
                    'method': 'post',
                    'className': 'cm_product-item__buttons-form',
                    'id': this.id,
                    'encType': 'multipart/form-data'
                }, this.out_of_stock ? _createElement('button', {
                    'className': 'cm_button cm_button__primary button',
                    'disabled': true,
                    'key': '2841'
                }, '\n        ', _translate(`product_out_of_stock`), '\n      ') : null, !this.out_of_stock && this.variant_ids.length === 1 && (!this.ProductScope || this.ProductScope === 'child') ? [
                    _createElement('input', {
                        'type': 'hidden',
                        'name': 'id',
                        'value': this.variant_ids,
                        'key': '30001'
                    }),
                    _createElement('input', {
                        'type': 'hidden',
                        'name': 'quantity',
                        'value': this.set_qty || 1,
                        'key': '30003'
                    }),
                    this.fitsTheVehicle && !window.Convermax.config?.hideVerifyOnCartItems ? _createElement('input', {
                        'type': 'hidden',
                        'name': 'properties[Fitment]',
                        'value': this.getVerifyFitmentOrderNotes(this.fitsTheVehicle),
                        'key': '30005'
                    }) : null,
                    _createElement('button', {
                        'className': 'cm_button cm_button__primary button',
                        'type': 'submit',
                        'data-form-id': this.id,
                        'onClick': e => window.Convermax.addToCart(e),
                        'key': '30007'
                    }, '\n          ', _translate(`product_add_to_cart`), this.set_qty ? ` ${ _translate(`product_set_of`, {  count: this.set_qty  }) }` : '', '\n        ')
                ] : null, !this.out_of_stock && (this.variant_ids.length > 1 || this.ProductScope === 'master') ? _createElement('a', {
                    'href': this.url,
                    'className': 'cm_button cm_button__secondary button',
                    'key': '3847'
                }, '\n        ', _translate(`product_select_options`), '\n      ') : null), [scopeProduct4.apply(this, [])]));
            }, { count: undefined })];
    }
    function scopeShowExactFitBadge2() {
        var showExactFitBadge = window.Convermax.isVehicleSelected() && !window.Convermax.getSearchResponse?.()?.messages.includes('IncompatibleParts');
        return _createElement('div', { 'className': 'cm_related-products' }, _createElement('div', { 'className': 'cm_related-products-title-container' }, _createElement('h2', { 'className': 'cm_related-products-title' }, _translate(`related_items_title`))), _createElement.apply(this, [
            'div',
            { 'className': 'cm_related-products-list cmRepeater_items' },
            _map(this.items, repeatItems1.bind(this, showExactFitBadge))
        ]));
    }
    return scopeShowExactFitBadge2.apply(this, []);
}
        export const componentNames = []